import type { LandingCompanyPlatformHeroContent, LandingContent, LandingLocale } from '../content/landingContent.js';

const previousCopy: Record<LandingLocale, Pick<LandingCompanyPlatformHeroContent, 'badge' | 'title' | 'highlight'>> = {
  de: { badge: 'Matching & Bewerbermanagement für Arbeitgeber', title: 'Endlich passende Fachkräfte gewinnen – und Bewerbungen an einem Ort steuern.', highlight: 'an einem Ort' },
  en: { badge: 'Matching and applicant management for employers', title: 'Finally attract the right skilled professionals – and manage applications in one place.', highlight: 'in one place' },
  tr: { badge: 'İşverenler için eşleştirme ve aday yönetimi', title: 'Doğru uzmanları bulun, tüm başvuruları tek bir yerden yönetin.', highlight: 'tek bir yerden' },
};

export const refreshCompanyPlatformHeroCopy = (
  content: LandingContent,
  fallback: LandingContent,
  locale: LandingLocale,
) => {
  const previous = previousCopy[locale];
  if (content.companyPlatformHero.badge === previous.badge) content.companyPlatformHero.badge = fallback.companyPlatformHero.badge;
  if (content.companyPlatformHero.title === previous.title) content.companyPlatformHero.title = fallback.companyPlatformHero.title;
  if (content.companyPlatformHero.highlight === previous.highlight) content.companyPlatformHero.highlight = fallback.companyPlatformHero.highlight;
};
